var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { darken } from 'polished';
import React from 'react';
import { space } from 'styled-system';
import { css, styled } from "../utils";
import Markdown from './Markdown';
var StyledMessage = styled.div(function (_a) {
    var status = _a.status, _b = _a.theme, colors = _b.colors, fontWeights = _b.fontWeights, space = _b.space;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: block;\n    background: ", ";\n    border-radius: 10px;\n    padding: ", ";\n    box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.2);\n\n    a {\n      display: inline;\n      color: ", ";\n      text-decoration: underline;\n      font-weight: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    }\n  "], ["\n    display: block;\n    background: ", ";\n    border-radius: 10px;\n    padding: ", ";\n    box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.2);\n\n    a {\n      display: inline;\n      color: ", ";\n      text-decoration: underline;\n      font-weight: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n    }\n  "])), colors.status[status], space[3], colors.primary, fontWeights.medium, darken(0.05, colors.primary));
}, space);
var Message = function (_a) {
    var _b = _a.status, status = _b === void 0 ? 'normal' : _b, children = _a.children, props = __rest(_a, ["status", "children"]);
    return (React.createElement(StyledMessage, __assign({ "data-component": "Message", status: status }, props), typeof children === 'string' ? React.createElement(Markdown, { source: children }) : children));
};
export default Message;
var templateObject_1;
//# sourceMappingURL=Message.js.map